import { getSelectedPostType, togglePostTypeCookie } from "./post-type-cookie";

declare const jQuery: any;
const $ = jQuery;

export function initPostTypeCookieSwitches(): void
{
    const $switches = $(`[data-switch="supplier-category-post-type"]`);

    if ($switches.length === 0)
    {
        return;
    }
    
    const updateSwitches = () => {
        if (getSelectedPostType() === "product")
        {
            $switches.removeClass("on");
        }
        else
        {
            $switches.addClass("on");
        }
    };

    updateSwitches();
    const eventName: string = ("ontouchstart" in window) ? "touchstart" : "click";
    $switches.on(eventName, togglePostTypeCookie);
    $(document).on("posttypechanged", updateSwitches);
}
